


































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue, { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';

import {
  IRequisition,
  User,
  IUser,
  RequisitionStatusEnum,
  RequisitionApprovalState,
  RequisitionStatus
} from '@/models';
import { Group } from '@vue-altoleap-libraries/vue-altoleap-accounts-lib/types/model/userData';

import { colors, classToHex } from '@/utils/colorUtils';
import { ErrorManager } from '@/models/error';
import { ExtractVue } from '@/utils/mixins';

import auth from '@/mixins/auth';

import RequisitionDetailFormDialog from '@/components/requisition/RequisitionDetailFormDialog.vue';
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';
import ErrorAlert from '../common/ErrorAlert.vue';

export default auth.extend({
  name: 'RequisitionStateCard',

  components: {
    RequisitionDetailFormDialog,
    ConfirmationDialog,
    ErrorAlert
  },

  props: {
    requisition: {
      type: Object as PropType<IRequisition>,
      required: true
    }
  },

  data: () => ({
    loading: false,
    errorMessage: '',
    errorMessageDetail: '',
    RequisitionStatusEnum,

    submitRequititionApprover: null as null | IUser,
    submitRequititionDialog: false,

    approveRequisitionApprover: null as null | IUser,
    approveRequisitionDialog: false,

    assignBuyerRequititionBuyer: null as null | IUser,
    assignBuyerRequititionDialog: false,

    purchaseRequititionDialog: false,
    purchaseOrder: '',

    assignRequisitionPONumberLoading: false,
    assignRequisitionPONumberDialog: false,
    // assign the current po_number to requisition po_number
    requisitionPONumber: '',

    cancelRequsititionDialog: false,
    closeRequsititionDialog: false,
    // comment sections
    commentsRequsititionDialog: false,
    resolve: (null as unknown) as (
      value: boolean | PromiseLike<boolean>
    ) => void,
    requisitionComment: '',
    actionLabel: '',

    didFetchNextApprovers: false
  }),

  computed: {
    ...mapGetters({
      approvers: 'requisition/getRequisitionApprovers'
    }),

    authProvider(): any {
      return this.$altoleapAccounts.authProvider;
    },

    currentUser(): User {
      return this.authProvider.getCurrentUser;
    },

    canApprove(): boolean {
      if (this.requisition.approvers && this.requisition.approvers.length) {
        const approver = this.requisition.approvers.find(requsitionApprover => {
          return (
            this.currentUser.id === (requsitionApprover.approver as IUser).id
          );
        });
        if (approver) {
          const isApproverTentative =
            approver.status === RequisitionApprovalState.TENTATIVE;
          return isApproverTentative;
        }
      }
      return false;
    },

    canBuy(): boolean {
      if (this.requisition.buyer) {
        return this.currentUser.id === (this.requisition.buyer as IUser).id;
      }
      return false;
    },

    canClose(): boolean {
      return this.currentUser.id === (this.requisition.owner as IUser).id;
    },

    canUndoSubmit(): boolean {
      return this.currentUser.id === (this.requisition.owner as IUser).id;
    },

    isRequisitionOwner(): boolean {
      return this.currentUser.id === (this.requisition.owner as IUser).id;
    },

    /**
     * If currentuser is main buyer and state is approved and buyer no assigned
     * @returns boolean
     */
    canAssignBuyer() {
      if (!this.requisition.buyer) {
        const userGroups: Group[] = this.authProvider.getCurrentUser.groups;
        const isMainBuyer = !!userGroups.find(
          ({ name }) => name === 'Main Buyer'
        );

        return isMainBuyer;
      }
      return false;
    },

    getStatusIcon(): string {
      switch (this.requisition.status!.value) {
        case RequisitionStatusEnum.Draft:
          return 'mdi-file-document-outline';

        case RequisitionStatusEnum.Submitted:
          return 'mdi-file-send-outline';

        case RequisitionStatusEnum.InReview:
          return 'mdi-file-send-outline';

        case RequisitionStatusEnum.Approval2Pending:
          return 'mdi-file-send-outline';

        case RequisitionStatusEnum.Approval3Pending:
          return 'mdi-file-send-outline';

        case RequisitionStatusEnum.Approval4Pending:
          return 'mdi-file-send-outline';

        case RequisitionStatusEnum.Approved:
          return 'mdi-file-send-outline';

        case RequisitionStatusEnum.Rejected:
          return 'mdi-file-send-outline';

        case RequisitionStatusEnum.BuyerAssigned:
          return 'mdi-file-send-outline';

        case RequisitionStatusEnum.PurchaseInProgress:
          return 'mdi-file-send-outline';

        case RequisitionStatusEnum.PurchaseDelivered:
          return 'mdi-file-send-outline';

        case RequisitionStatusEnum.Cancelled:
          return 'mdi-alert-circle';

        case RequisitionStatusEnum.Received:
          return 'mdi-checkbox-marked-circle-outline';

        default:
          return 'mdi-file-document-outline';
      }
    },

    getStatusMessage(): string {
      switch (this.requisition.status!.value) {
        case RequisitionStatusEnum.Draft:
          return 'Draft';

        case RequisitionStatusEnum.Submitted:
          return 'Submitted for approval';

        case RequisitionStatusEnum.InReview:
          return 'Review In Progress';

        case RequisitionStatusEnum.Approval2Pending:
          return 'Approval II Pending';

        case RequisitionStatusEnum.Approval3Pending:
          return 'Approval III Pending';

        case RequisitionStatusEnum.Approval4Pending:
          return 'Approval IV Pending';

        case RequisitionStatusEnum.Approved:
          return 'Approved';

        case RequisitionStatusEnum.Rejected:
          return 'Rejected';

        case RequisitionStatusEnum.BuyerAssigned:
          return 'Buyer Assigned';

        case RequisitionStatusEnum.PurchaseInProgress:
          return 'Purchase In Progress';

        case RequisitionStatusEnum.PurchaseDelivered:
          return 'Purchase Complete';

        case RequisitionStatusEnum.Cancelled:
          return 'Cancelled';

        case RequisitionStatusEnum.Received:
          return 'Received';

        default:
          return (this.requisition.status as RequisitionStatus).display_name;
      }
    },

    getStatusColor(): string {
      return this.requisition.status!.getColor();
    },

    getStatusHexColor(): string {
      return classToHex(
        this.requisition.status!.getColor(),
        colors,
        this.$vuetify.theme.currentTheme
      );
    },

    requisitionApprovalStates() {
      return [
        RequisitionStatusEnum.Approval2Pending,
        RequisitionStatusEnum.Approval3Pending,
        RequisitionStatusEnum.Approval4Pending
      ];
    },

    errorOccurred(): boolean {
      return this.errorMessage.length > 0;
    }
  },

  mounted() {
    this.loadNextRequisitionApprovers();
  },

  methods: {
    ...mapActions({
      updateRequisitionState: 'requisition/updateRequisitionState',
      exportRequisitionLines: 'requisition/exportRequisitionLines',
      exportRequisitionHeader: 'requisition/exportRequisitionHeader',
      fetchRequisitionApprovers: 'requisition/fetchRequisitionApprovers',
      assignRequisitionPONumber: 'requisition/assignRequisitionPONumber',
      fetchRequisitionActivities: 'requisition/fetchRequisitionActivities'
    }),

    setActionLabel(state: RequisitionStatusEnum) {
      switch (state) {
        case RequisitionStatusEnum.Draft:
          this.actionLabel = '';
          break;

        case RequisitionStatusEnum.Submitted:
          this.actionLabel = 'Submit';
          break;

        case RequisitionStatusEnum.InReview:
        case RequisitionStatusEnum.Approval2Pending:
        case RequisitionStatusEnum.Approval3Pending:
        case RequisitionStatusEnum.Approval4Pending:
          this.actionLabel = 'Start Review';
          break;

        case RequisitionStatusEnum.Approved:
          this.actionLabel = 'Approve';
          break;

        case RequisitionStatusEnum.Rejected:
          this.actionLabel = 'Reject';
          break;

        case RequisitionStatusEnum.BuyerAssigned:
          this.actionLabel = 'Assign Buyer';
          break;

        case RequisitionStatusEnum.PurchaseInProgress:
          this.actionLabel = 'Start Purchase';
          break;

        case RequisitionStatusEnum.PurchaseDelivered:
          this.actionLabel = 'Complete Purchase';
          break;

        case RequisitionStatusEnum.Cancelled:
          this.actionLabel = 'Cancel';
          break;

        case RequisitionStatusEnum.Received:
          this.actionLabel = 'Close';
          break;

        default:
          this.actionLabel = 'Submit';
          break;
      }
    },

    updateRequisition(): void {
      const requisitionFormDialog = this.$refs
        .requisitionDetailFormDialog as ExtractVue<
        typeof RequisitionDetailFormDialog
      >;
      requisitionFormDialog.open(this.requisition, true);
    },

    cancelledApproverDialog(): void {
      switch (this.requisition.status?.value) {
        case RequisitionStatusEnum.Submitted:
          return this.undoSubmit();

        case RequisitionStatusEnum.InReview:
        case RequisitionStatusEnum.Approval2Pending:
        case RequisitionStatusEnum.Approval3Pending:
        case RequisitionStatusEnum.Approval4Pending:
          return;

        default:
          return;
      }
    },

    getIcon(): string {
      switch (this.requisition.status!.value) {
        case RequisitionStatusEnum.Draft:
          return 'mdi-file-document-outline';

        case RequisitionStatusEnum.Submitted:
          return 'mdi-file-send-outline';

        case RequisitionStatusEnum.Approved:
          return 'mdi-check';

        case RequisitionStatusEnum.Rejected:
        case RequisitionStatusEnum.Cancelled:
          return 'mdi-close';

        default:
          return 'mdi-help';
      }
    },

    agreeCommentsDialog() {
      this.commentsRequsititionDialog = false;
      return this.resolve(true);
    },

    cancelCommentsDialog() {
      this.commentsRequsititionDialog = false;
      return this.resolve(false);
    },

    /**
     * @summary Await this dialog to close before continuing into the next action.
     */
    openCommentsDialog(toState: RequisitionStatusEnum) {
      this.setActionLabel(toState);

      this.requisitionComment = '';
      this.commentsRequsititionDialog = true;

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
      });
    },
    /**
     * @see api requisition/store/exportRequisitionLines
     * can be called only from states:
     * - PurchaseInProgress
     *
     * generates lines as a csv file
     *
     * only callable by user with @see canBuy
     */
    exportLines(purchaseOrder: string) {
      this.clearAllErrors();
      this.loading = true;
      this.exportRequisitionLines({
        requisitionId: this.requisition.id,
        purchaseOrder: purchaseOrder
      })
        .then((data: Blob) => {
          this.purchaseRequititionDialog = false;
          this.purchaseOrder = '';
          this.createLineFile({ data, id: this.requisition.id! });
        })
        .catch(error => {
          if (error.response && error.response.data.detail) {
            this.errorMessageDetail = error.response.data.detail;
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    /**
     * @see api requisition/store/exportRequisitionHeader
     * can be called only from states:
     * - PurchaseInProgress
     *
     * generates header as a csv file
     *
     * only callable by user with @see canBuy
     */
    exportHeader() {
      this.clearAllErrors();
      this.loading = true;
      this.exportRequisitionHeader(this.requisition.id)
        .then((data: Blob) => {
          this.createHeaderFile({ data, id: this.requisition.id! });
        })
        .catch(error => {
          if (error.response && error.response.data.detail) {
            this.errorMessageDetail = error.response.data.detail;
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    /**
     * @see api requisition/models/start_review
     * can be called only from states:
     * - Draft
     *
     * can go to states
     * - Submitted
     *
     * if approver not assigned then call @see undoSubmit
     */
    submit(assignee: number): void {
      this.clearAllErrors();
      this.loading = true;
      this.updateRequisitionState({
        requisitionId: this.requisition.id,
        state: RequisitionStatusEnum.Submitted,
        assignee: assignee
      })
        .then(() => {
          this.submitRequititionDialog = false;
          this.submitRequititionApprover = null;
          this.$emit('submitted');
          this.fetchRequisitionActivities(this.requisition.id);
        })
        .catch(error => {
          if (error.response && error.response.data.detail) {
            this.errorMessageDetail = error.response.data.detail;
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    /**
     * @see api requisition/models/start_review
     * can be called only from states:
     * - Submitted
     *
     * can go to states
     * - Draft
     */
    undoSubmit() {
      this.clearAllErrors();
      this.loading = true;
      this.updateRequisitionState({
        requisitionId: this.requisition.id,
        state: RequisitionStatusEnum.Draft
      })
        .then(() => {
          this.$emit('undo-submit');
          this.loadNextRequisitionApprovers();
          this.fetchRequisitionActivities(this.requisition.id);
        })
        .catch(error => {
          if (error.response && error.response.data.detail) {
            this.errorMessageDetail = error.response.data.detail;
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    /**
     * @see api requisition/models/start_review
     * can be called only from states:
     * - Submitted
     *
     * can go to states
     * - InReview
     */
    startReview(): void {
      this.clearAllErrors();
      this.loading = true;
      this.updateRequisitionState({
        requisitionId: this.requisition.id,
        state: RequisitionStatusEnum.InReview
      })
        .then(() => {
          this.$emit('start-review');
          this.loadNextRequisitionApprovers();
          this.fetchRequisitionActivities(this.requisition.id);
        })
        .catch(error => {
          if (error.response && error.response.data.detail) {
            this.errorMessageDetail = error.response.data.detail;
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    /**
     * @see api requisition/models/reject
     * @param {number} assignee
     * can be called only from states:
     * - Any State
     *
     * can go to states
     * - Rejected
     */
    async reject(assignee: number): Promise<void> {
      if (await this.openCommentsDialog(RequisitionStatusEnum.Rejected)) {
        this.clearAllErrors();
        this.loading = true;
        this.updateRequisitionState({
          requisitionId: this.requisition.id,
          state: RequisitionStatusEnum.Rejected,
          assignee: assignee, //only current user can reject a requistion,
          comment: this.requisitionComment
        })

          .then(() => {
            this.$emit('reject');
            this.fetchRequisitionActivities(this.requisition.id);
          })
          .catch(error => {
            if (error.response && error.response.data.detail) {
              this.errorMessageDetail = error.response.data.detail;
            }
            this.errorMessage = ErrorManager.extractApiError(error);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    /**
     * @see api requisition/models/approve
     * @param {number} assignee
     * can be called only from states:
     * - InReview
     * - Approval2Pending
     * - Approval3Pending
     * - Approval4Pending
     *
     * can go to states
     * - Approved
     * - Approval2Pending
     * - Approval3Pending
     * - Approval4Pending
     */
    async approve(assignee: number): Promise<void> {
      if (await this.openCommentsDialog(RequisitionStatusEnum.Approved)) {
        this.clearAllErrors();
        this.loading = true;

        this.updateRequisitionState({
          requisitionId: this.requisition.id,
          state: RequisitionStatusEnum.Approved,
          assignee: assignee,
          comment: this.requisitionComment
        })
          .then(() => {
            this.approveRequisitionApprover = null;
            this.approveRequisitionDialog = false;
            this.$emit('approved');
            this.fetchRequisitionActivities(this.requisition.id);
          })
          .catch(error => {
            if (error.response && error.response.data.detail) {
              this.errorMessageDetail = error.response.data.detail;
            }
            this.errorMessage = ErrorManager.extractApiError(error);
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.approveRequisitionDialog = false;
      }
    },

    /**
     * @see api requisition/models/assign_buyer
     * can be called only from states:
     * - Approved
     *
     * can go to states
     * - BuyerAssigned
     */
    async assignBuyer(assignee: number): Promise<void> {
      if (await this.openCommentsDialog(RequisitionStatusEnum.BuyerAssigned)) {
        this.clearAllErrors();
        this.loading = true;
        this.updateRequisitionState({
          requisitionId: this.requisition.id,
          state: RequisitionStatusEnum.BuyerAssigned,
          assignee: assignee,
          comment: this.requisitionComment
        })
          .then(() => {
            this.assignBuyerRequititionDialog = false;
            this.assignBuyerRequititionBuyer = null;
            this.$emit('assign-buyer');
            this.fetchRequisitionActivities(this.requisition.id);
          })
          .catch(error => {
            if (error.response && error.response.data.detail) {
              this.errorMessageDetail = error.response.data.detail;
            }
            this.errorMessage = ErrorManager.extractApiError(error);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    /**
     * @see api requisition/models/start_purchase
     * can be called only from states:
     * - BuyerAssigned
     *
     * can go to states
     * - PurchaseInProgress
     */
    async startPurchase(): Promise<void> {
      if (
        await this.openCommentsDialog(RequisitionStatusEnum.PurchaseInProgress)
      ) {
        this.clearAllErrors();
        this.loading = true;
        this.updateRequisitionState({
          requisitionId: this.requisition.id,
          state: RequisitionStatusEnum.PurchaseInProgress,
          comment: this.requisitionComment
        })
          .then(() => {
            this.$emit('start-purchase');
            this.fetchRequisitionActivities(this.requisition.id);
          })
          .catch(error => {
            if (error.response && error.response.data.detail) {
              this.errorMessageDetail = error.response.data.detail;
            }
            this.errorMessage = ErrorManager.extractApiError(error);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    /**
     * @see api requisition/models/complete_purchase
     * can be called only from states:
     * - PurchaseInProgress
     *
     * can go to states
     * - PurchaseDelivered
     */
    async completePurchase(): Promise<void> {
      if (
        await this.openCommentsDialog(RequisitionStatusEnum.PurchaseDelivered)
      ) {
        this.clearAllErrors();
        this.loading = true;
        this.updateRequisitionState({
          requisitionId: this.requisition.id,
          state: RequisitionStatusEnum.PurchaseDelivered,
          comment: this.requisitionComment
        })
          .then(() => {
            this.$emit('complete-purchase');
            this.fetchRequisitionActivities(this.requisition.id);
          })
          .catch(error => {
            if (error.response && error.response.data.detail) {
              this.errorMessageDetail = error.response.data.detail;
            }
            this.errorMessage = ErrorManager.extractApiError(error);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    setPONumberThenCompletePurchase(poNumber?: string) {
      this.clearAllErrors();
      this.loading = true;
      //  set po number first then make state callback on success
      // pass error back up into this funcion to handle
      this.setRequisitionPONumber(poNumber)
        .then(() => {
          this.completePurchase();
          this.fetchRequisitionActivities(this.requisition.id);
        })
        .catch(error => {
          if (error.response && error.response.data.detail) {
            this.errorMessageDetail = error.response.data.detail;
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    /**
     * @see api requisition/models/cancel
     * can be called only from states:
     * - Any state
     *
     * can go to states
     * - Cancel
     */
    async cancel(): Promise<void> {
      if (await this.openCommentsDialog(RequisitionStatusEnum.Cancelled)) {
        this.clearAllErrors();
        this.loading = true;
        this.updateRequisitionState({
          requisitionId: this.requisition.id,
          state: RequisitionStatusEnum.Cancelled,
          comment: this.requisitionComment
        })
          .then(() => {
            this.$emit('cancel');
            this.fetchRequisitionActivities(this.requisition.id);
          })
          .catch(error => {
            if (error.response && error.response.data.detail) {
              this.errorMessageDetail = error.response.data.detail;
            }
            this.errorMessage = ErrorManager.extractApiError(error);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    /**
     * @see api requisition/models/close
     * can be called only from states:
     * - Rejected
     * - Cancelled
     * - Purchase Complete
     *
     * can go to states
     * - Close
     */
    async close(): Promise<void> {
      if (await this.openCommentsDialog(RequisitionStatusEnum.Received)) {
        this.clearAllErrors();
        this.updateRequisitionState({
          requisitionId: this.requisition.id,
          state: RequisitionStatusEnum.Received
        })
          .then(() => {
            this.closeRequsititionDialog = false;
            this.$emit('close');
            this.fetchRequisitionActivities(this.requisition.id);
          })
          .catch(error => {
            if (error.response && error.response.data.detail) {
              this.errorMessageDetail = error.response.data.detail;
            }
            this.errorMessage = ErrorManager.extractApiError(error);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    clearAllErrors(): void {
      this.errorMessage = '';
      this.errorMessageDetail = '';
    },

    /**
     * Creates a csv file from server blob data
     */
    createHeaderFile({ data, id }: { data: Blob; id: number }) {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      const linkName = `${id}-po_header-${moment(new Date()).format(
        'YYYY-MM-DD-HH-mm-ss'
      )}.csv`;
      link.href = url;

      link.setAttribute('download', linkName); //or any other extension
      document.body.appendChild(link);
      link.click();
    },

    /**
     * Creates a csv file from server blob data
     */
    createLineFile({ data, id }: { data: Blob; id: number }) {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      const linkName = `${id}-po_lines-${moment(new Date()).format(
        'YYYY-MM-DD-HH-mm-ss'
      )}.csv`;
      link.href = url;

      link.setAttribute('download', linkName); //or any other extension
      document.body.appendChild(link);
      link.click();
    },

    approveIfNoApproversList(assignee: number) {
      if (this.approvers.length) {
        this.approveRequisitionDialog = true;
      } else {
        this.approve(assignee);
      }
    },

    loadNextRequisitionApprovers() {
      this.loading = true;
      return this.fetchRequisitionApprovers(this.requisition.id)
        .then(() => {
          this.didFetchNextApprovers = true;
        })
        .catch(() => {
          this.didFetchNextApprovers = false;
          this.errorMessage = 'Error getting approvers';
        })
        .finally(() => (this.loading = false));
    },

    async setRequisitionPONumber(po_number?: string) {
      this.assignRequisitionPONumberLoading = true;
      return this.assignRequisitionPONumber({
        requisitionId: this.requisition.id,
        po_number
      }).finally(() => {
        this.assignRequisitionPONumberLoading = false;
      });
    }
  }
});
